type CyDomainObject = {
    [index: string]: string;
    prod: string;
    sandbox: string;
    dev: string;
    local: string;
};

export interface FncImpl {
    // eslint-disable-next-line no-unused-vars
    (data: object): void;
}

export type FncNullable = FncImpl | undefined;
export type EmptyObject = Record<string, never>;
export interface Result {
    resultCd: string,
    resultMsg: string,
    advanceMsg: string | null,
    originalMsg: string | null
}

export const modeTypes = ['dev', 'local', 'sandbox', 'prod'];
export const ServerDomainArray: CyDomainObject = {
    prod: 'https://api.cyrexpay.com',
    sandbox: 'https://dapi.cyrexpay.com',
    dev: 'https://tapi.cyrexpay.com',
    local: '',
};
